import {
  Flex,
  Heading,
  IconButton,
  Tooltip,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { formatDateWithAmPm } from "../../../utils/DateFormat/dateFormatWithTimeAmPm";
import { fetchController } from "../../../utils/FetchController/fetchController";
import Loader from "../../../utils/Loader/Loader";
import PaginationSizeSelect from "../../../utils/Loader/PaginationSizeSelect";
import Paginator from "../../../utils/Loader/Paginator";
import { getHostDomain } from "../../../utils/utils";
import AddApiKey from "../../Modals/AddApiKey";
import Table from "../../Tables/Table";
import { AgencyContext } from "../AgencyProvider/AgencyProvider";
import { AddIcon } from "@chakra-ui/icons";

const ApiKey = () => {
  const baseUrl = getHostDomain();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [status, setStatus] = useState("idle");
  const [tableData, setTableData] = useState([]);
  const [heads, setHeads] = useState([]);
  const loading = status === "loading" && isInitialLoad;
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [paginationSize, setPaginationSize] = useState(10);

  const hitFetch = async () => {
    try {
      const endpoint = `/api/v1/apikey/list?page=${page}&size=${paginationSize}`;
      setStatus("loading");
      const urlHit = baseUrl + endpoint;

      const getData = await fetchController(urlHit, "GET");
      setPages(getData?.data?.pages);
      if (getData?.data) {
        const updatedData = getData.data.items.map((item, index) => {
          return {
            SNo: index + 1,
            id: item.id,
            name: item.name,
            description: item.description,
            apiKeyRole: item.api_key_role,
            "Created at": formatDateWithAmPm(item.created_at, "short"),
            "Last Used": formatDateWithAmPm(item?.last_used, "short"),
          };
        });

        const heads = ["SNo", "name", "description", "Created at", "Last Used"];
        const columns = heads.map((key) => ({
          Header: key,
          accessor: key,
          Filter: ({ column }) => <input {...column.filterProps} />,
        }));
        setTableData(updatedData);
        setHeads(columns);
        setStatus("success");
        setIsInitialLoad(false);
      }
    } catch (error) {
      setStatus("failure");
    }
  };
  useEffect(() => {
    hitFetch();
  }, [page, paginationSize]);
  const agency = useContext(AgencyContext);
  const { textColor, buttonColorScheme } = agency;

  return (
    <>
      <Flex direction={"column"} gap={3} h={"95%"} w={"100%"}>
        <Flex gap={2} w={"100%"} alignItems="center" p={2}>
          <Heading color={textColor} fontSize="xl">
            API Keys
          </Heading>
          <Tooltip label="Generate a key">
            <IconButton
              colorScheme={buttonColorScheme}
              onClick={() => onOpen()}
              icon={<AddIcon />}
              size={"xs"}
            />
          </Tooltip>
        </Flex>

        {loading ? (
          <Loader />
        ) : (
          <Table
            fetch={hitFetch}
            columns={heads}
            data={tableData}
            table="apikey"
          />
        )}
      </Flex>

      <Flex
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap={2}
        w={"100%"}
      >
        <PaginationSizeSelect
          paginationSize={paginationSize}
          setPaginationSize={setPaginationSize}
          tableLength={tableData.length}
        />
        <Paginator
          colorScheme={buttonColorScheme}
          onChangePage={setPage}
          page={page}
          pages={pages}
        />
      </Flex>

      <AddApiKey
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        fetchApiKeyList={hitFetch}
        buttonColorScheme={buttonColorScheme}
        textColor={textColor}
      />
    </>
  );
};

export default ApiKey;
